export default __webpack_public_path__ + "static/poster-widget-cdad174e8d590e155493fbcfe77880c9.mp4";